module.exports = __webpack_public_path__ + "img/show.a509a724.svg";